import React from 'react';
import { useOnboarding } from '../OnboardingProvider';
import { classNames } from '../../../Services/helpers';

const Progress = () => {
    const {steps, step: currentStep, goTo, draft} = useOnboarding();
    const progressSteps = steps.filter(step => step !== 'intro');
    const currentIndex = progressSteps.indexOf(currentStep);

    return <div className="mb-6" aria-label={`Step ${currentIndex + 1} of ${progressSteps.length}`}>
        <div className="flex gap-x-1.5">
            {progressSteps.map((step, index) => {
                const isCompleted = draft.completedSteps.includes(step);
                const canJump = isCompleted && index < currentIndex;

                return <button
                    key={step}
                    type="button"
                    onClick={canJump ? () => goTo(step) : undefined}
                    disabled={!canJump}
                    aria-label={`Step ${index + 1}`}
                    className={classNames(
                        'h-1.5 flex-1 rounded-full transition-colors',
                        index <= currentIndex ? 'bg-brand' : 'surface-2',
                        canJump ? 'cursor-pointer' : 'cursor-default',
                    )}
                />;
            })}
        </div>
        {/* <p className="mt-2 text-xs text-muted">Step {stepIndex + 1} of {steps.length}</p> */}
    </div>;
};

export default Progress;
